import { computed } from 'vue'
import { useI18n } from 'vue-i18n'

export default function usePaymentTerm(paymentTerm) {
  const { te, t } = useI18n()

  const paymentTermLabel = computed(() => {
    if (paymentTerm?.code && te('paymentTerm.choices.' + paymentTerm.code)) {
      return t('paymentTerm.choices.' + paymentTerm.code)
    }
    return paymentTerm?.label && te(paymentTerm.label) ? t(paymentTerm.label) : ''
  })

  return {
    paymentTermLabel,
  }
}
